import { Box, Text } from '@cmpsr/components';

type HeaderProps = {
  headlineText: string;
  subheadlineText?: string;
  children?: React.ReactNode;
};

export default function TrendHeaderRisks({ headlineText, subheadlineText, children }: HeaderProps) {
  return (
    <Box
      py={{ base: 'spacer-4', md: 'spacer-5', lg: 'spacer-9', xl: 'spacer-12' }}
      px={{ base: 'spacer-5', md: 'spacer-8', lg: 'spacer-16', xl: 'spacer-24', xxl: 'spacer-32' }}
      maxWidth="1440px"
      marginX="auto"
    >
      <Text variant="text-header-XS" textTransform="uppercase" mb={{ base: 'spacer-2', lg: 'spacer-4' }}>
        cancer risk
      </Text>
      <Text variant="text-header-4XL">
        {headlineText}{' '}
        <Text as="span" textStyle="text-header-4xl-v">
          {subheadlineText}
        </Text>
      </Text>
      {children}
    </Box>
  );
}
